export const validateCitizenshipDocument = (text: string): boolean => {
  // Clean and normalize the text: remove extra spaces, line breaks, and convert to lowercase
  const normalizedText = text.replace(/[\n\r]+/g, ' ')  // Replace line breaks with spaces
                            .replace(/\s+/g, ' ')        // Replace multiple spaces with single space
                            .trim()                      // Remove leading/trailing spaces
                            .toLowerCase();              // Convert to lowercase
  
  // Update patterns to use lowercase and be more flexible with spaces
  const passportPattern = /united states of america/;
  const passportCardPattern = /passport/;
  
  return passportPattern.test(normalizedText) && passportCardPattern.test(normalizedText);
};
  